module.exports = __webpack_public_path__ + "assets/img/34@3x.a8be92c2.png";